import { CustomTabs } from './custom-tabs';
export var Tabs = CustomTabs;